<template>
  <div class="user-page">
    <el-row class="user-page__row">
      <p class="page-form-title">User Review page</p>
      <p class="page-form-tip">User review related operations.</p>
      <el-button
        icon="el-icon-refresh"
        @click.native="getUsers"
        :loading="isLoading"
        class="user-page__row-refresh"
        >REFRESH</el-button
      >
      <el-table :data="users" stripe style="width: 100%" v-loading="isLoading">
        <el-table-column prop="id" label="ID"> </el-table-column>
        <el-table-column prop="nickname" label="Name">
          <template slot-scope="scope">
            {{ scope.row.nickname.match(/(\S*)@/)[1] }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="Status">
          <template slot-scope="scope">
            <el-tag
              type="primary"
              disable-transitions
              v-if="scope.row.status === 'pending'"
              >{{ scope.row.status }}
            </el-tag>
            <el-tag
              type="danger"
              disable-transitions
              v-if="scope.row.status === 'rejected'"
              >{{ scope.row.status }}
            </el-tag>
            <el-tag
              type="success"
              disable-transitions
              v-if="
                scope.row.status === 'approved' ||
                  scope.row.status === 'creating'
              "
              >{{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Operations">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="handleApprove(scope.$index, scope.row)"
              v-if="scope.row.status === 'pending'"
              ><i class="el-icon-check"></i>APPROVE</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleReject(scope.$index, scope.row)"
              v-if="scope.row.status === 'pending'"
              ><i class="el-icon-close"></i>REJECT</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="page"
        :page-size="per_page"
        @current-change="getUsers"
        class="user-page__pagination"
      >
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'users-page',

  data() {
    return {
      users: undefined,
      isLoading: false,
      total: null,
      per_page: 15,
      page: 1
    }
  },

  methods: {
    ...mapActions(['signup']),
    handleApprove(index, row) {
      this.$prompt(
        'If you are sure to approve this user, please enter the private key.',
        'Comfirm',
        {
          confirmButtonText: 'Comfirm',
          cancelButtonText: 'Cancel',
          inputPattern: /^[A-Fa-f0-9]{64}$/,
          inputErrorMessage: 'Private key has to be 64 characters in length.',
          inputPlaceholder: 'Please enter the admin private key'
        }
      ).then(({ value }) => {
        this.approveUser(row, value)
      })
    },
    handleReject(index, row) {
      this.$prompt(
        'If you are sure to reject this user, please enter the private key.',
        'Comfirm',
        {
          confirmButtonText: 'Comfirm',
          cancelButtonText: 'Cancel',
          inputPattern: /^[A-Fa-f0-9]{64}$/,
          inputErrorMessage: 'Private key has to be 64 characters in length.',
          inputPlaceholder: 'Please enter the admin private key'
        }
      ).then(({ value }) => {
        this.rejectUser(row, value)
      })
    },
    approveUser(user, privateKey) {
      this.isLoading = true
      this.$axios({
        method: 'put',
        url: `/api/users/${user.nickname}`,
        params: {
          status: 'approved'
        }
      })
        .then((response) => {
          this.signUp(user.nickname, user.public_key, privateKey)
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    },
    rejectUser(user, privateKey) {
      this.isLoading = true
      this.$axios({
        method: 'put',
        url: `/api/users/${user.nickname}`,
        params: {
          status: 'rejected'
        }
      })
        .then((response) => {
          this.$message({
            message: 'Operation succeed',
            type: 'success'
          })
          this.getUsers()
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    },
    signUp(username, publicKey, privateKey) {
      this.signup({
        username: username,
        publicKey: publicKey,
        privateKeys: [privateKey]
      })
        .then(() => {
          this.$message({
            message: 'Operation succeed',
            type: 'success'
          })
          this.getUsers()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getUsers() {
      this.isLoading = true
      this.$axios({
        method: 'get',
        url: '/api/users',
        params: {
          page: this.page,
          per_page: this.per_page
        }
      })
        .then((response) => {
          this.total = parseInt(response.headers['x-total'])
          this.users = response.data
          this.isLoading = false
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    }
  },

  created() {
    this.getUsers()
  }
}
</script>

<style scoped lang="scss">
.user-page {
  &__row {
    padding: 2rem;
    &-refresh {
      margin-bottom: 1rem;
    }
  }
  &__tags {
    margin: 0.1rem;
  }
  &__pagination {
    margin-top: 2rem;
  }
}
</style>
